var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCashOnDeposit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.1376 30.7519H0.77502C0.481362 30.7519 0.278293 30.4583 0.381884 30.1835L2.05681 25.7406C2.11849 25.5769 2.27508 25.4686 2.44994 25.4686H9.46265C9.63752 25.4686 9.7941 25.5769 9.85579 25.7406L11.5307 30.1835C11.6343 30.4583 11.4312 30.7519 11.1376 30.7519Z",
    fill: "url(#paint0_radial_528_1463)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1816 30.7519H12.8191C12.5254 30.7519 12.3223 30.4583 12.4259 30.1835L14.1009 25.7406C14.1625 25.5769 14.3191 25.4686 14.494 25.4686H21.5067C21.6816 25.4686 21.8381 25.5769 21.8998 25.7406L23.5748 30.1835C23.6783 30.4583 23.4753 30.7519 23.1816 30.7519Z",
    fill: "url(#paint1_radial_528_1463)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2257 30.7519H24.8631C24.5695 30.7519 24.3664 30.4583 24.47 30.1835L26.1449 25.7406C26.2066 25.5769 26.3632 25.4686 26.538 25.4686H33.5507C33.7256 25.4686 33.8822 25.5769 33.9439 25.7406L35.6188 30.1835C35.7224 30.4583 35.5193 30.7519 35.2257 30.7519Z",
    fill: "url(#paint2_radial_528_1463)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1596 24.6283H6.79704C6.50338 24.6283 6.30032 24.3347 6.40391 24.0599L8.07883 19.617C8.14051 19.4534 8.2971 19.3451 8.47197 19.3451H15.4847C15.6595 19.3451 15.8161 19.4534 15.8778 19.617L17.5527 24.0599C17.6563 24.3347 17.4533 24.6283 17.1596 24.6283Z",
    fill: "url(#paint3_radial_528_1463)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2036 24.6283H18.8411C18.5474 24.6283 18.3444 24.3347 18.448 24.0599L20.1229 19.617C20.1846 19.4534 20.3411 19.3451 20.516 19.3451H27.5287C27.7036 19.3451 27.8602 19.4534 27.9219 19.617L29.5968 24.0599C29.7004 24.3347 29.4973 24.6283 29.2036 24.6283Z",
    fill: "url(#paint4_radial_528_1463)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1816 18.5048H12.8191C12.5254 18.5048 12.3223 18.2112 12.4259 17.9364L14.1009 13.4935C14.1625 13.3299 14.3191 13.2215 14.494 13.2215H21.5067C21.6816 13.2215 21.8381 13.3299 21.8998 13.4935L23.5748 17.9364C23.6783 18.2112 23.4753 18.5048 23.1816 18.5048Z",
    fill: "url(#paint5_radial_528_1463)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5237 3.52921C21.5237 3.75888 21.3388 3.94936 21.1035 3.94936C19.6283 3.94936 18.4146 5.13863 18.4146 6.62707C18.4146 6.86238 18.2298 7.04722 17.9945 7.04722C17.7648 7.04722 17.5743 6.86238 17.5743 6.62707C17.5743 5.14819 16.3699 3.94936 14.8966 3.94936C14.6613 3.94936 14.4764 3.75888 14.4764 3.52921C14.4764 3.29394 14.6613 3.10907 14.8966 3.10907C16.3604 3.10907 17.5743 1.91593 17.5743 0.420144C17.5743 0.184839 17.7648 0 17.9945 0C18.2298 0 18.4146 0.184839 18.4146 0.420144C18.4146 1.8999 19.6168 3.10907 21.1035 3.10907C21.3388 3.10907 21.5237 3.29394 21.5237 3.52921Z",
    fill: "url(#paint6_radial_528_1463)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8044 11.5512C11.8044 11.7809 11.6139 11.9714 11.3843 11.9714C9.90343 11.9714 8.69535 13.1508 8.69535 14.6491C8.69535 14.8844 8.50488 15.0692 8.27521 15.0692C8.03994 15.0692 7.85507 14.8844 7.85507 14.6491C7.85507 13.1702 6.65064 11.9714 5.17171 11.9714C4.94205 11.9714 4.75157 11.7809 4.75157 11.5512C4.75157 11.3159 4.94205 11.1311 5.17171 11.1311C6.62547 11.1311 7.85507 9.94889 7.85507 8.43654C7.85507 8.20684 8.03994 8.0164 8.27521 8.0164C8.50488 8.0164 8.69535 8.20684 8.69535 8.43654C8.69535 9.93519 9.90086 11.1311 11.3843 11.1311C11.6139 11.1311 11.8044 11.3159 11.8044 11.5512Z",
    fill: "url(#paint7_radial_528_1463)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.223 12.2066C32.223 12.4419 32.0381 12.6267 31.8029 12.6267C30.3378 12.6267 29.1139 13.8125 29.1139 15.3101C29.1139 15.5398 28.9291 15.7302 28.6938 15.7302C28.4641 15.7302 28.2737 15.5398 28.2737 15.3101C28.2737 13.8312 27.0692 12.6267 25.5959 12.6267C25.3606 12.6267 25.1758 12.4419 25.1758 12.2066C25.1758 11.9769 25.3606 11.7864 25.5959 11.7864C27.0971 11.7864 28.2737 10.5685 28.2737 9.09752C28.2737 8.86783 28.4641 8.67738 28.6938 8.67738C28.9291 8.67738 29.1139 8.86783 29.1139 9.09752C29.1139 10.5509 30.2776 11.7864 31.8029 11.7864C32.0381 11.7864 32.223 11.9769 32.223 12.2066Z",
    fill: "url(#paint8_radial_528_1463)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_528_1463",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.0003 15) rotate(90) scale(51 58.5291)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1261BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1261BC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_528_1463",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.0003 15) rotate(90) scale(51 58.5291)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1261BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1261BC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_528_1463",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.0003 15) rotate(90) scale(51 58.5291)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1261BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1261BC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_528_1463",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.0003 15) rotate(90) scale(51 58.5291)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1261BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1261BC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_528_1463",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.0003 15) rotate(90) scale(51 58.5291)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1261BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1261BC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_528_1463",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.0003 15) rotate(90) scale(51 58.5291)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1261BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1261BC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_528_1463",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.0003 15) rotate(90) scale(51 58.5291)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1261BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1261BC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_528_1463",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.0003 15) rotate(90) scale(51 58.5291)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1261BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1261BC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_528_1463",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.0003 15) rotate(90) scale(51 58.5291)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1261BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1261BC",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashOnDeposit);
export default __webpack_public_path__ + "static/media/cash_on_deposit.08c44cba8093f341af69ad943e071353.svg";
export { ForwardRef as ReactComponent };